<template>
    <div>
        <b-overlay :opacity="overlay.opacity" :show="overlay.visible" rounded="sm">
            <b-container class="mt-3" fluid>
                <!-- table toolbar -->
                <table-toolbar
                    :columns-filter="tableToolbarColumns"
                    :columns-show="tableToolbarColumns"
                    :locale-key="localeKey"
                    :options="tableToolbar.options"
                    :response.sync="tableToolbar.response"
                    @eventNew="toolbarTableEventNew"
                    @eventRefresh="toolbarTableEventRefresh"
                ></table-toolbar>
                <!-- table -->
                <b-table
                    id="main-table"
                    :current-page="tableToolbar.options.pagination.currentPage"
                    :fields="tableColumns"
                    :filter="tableToolbar.response.filter === undefined ? null : tableToolbar.response.filter.search"
                    :filterIncludedFields="tableToolbar.response.filter === undefined ? null : tableToolbar.response.filter.columnsOn"
                    :items="tableItems"
                    :per-page="tableToolbar.options.pagination.perPage"
                    :sort-by.sync="table.sortBy"
                    :sort-desc.sync="table.sortDesc"
                    bordered head-row-variant="dark" hover outlined
                    responsive
                    striped
                    table-variant="light"
                    thead-class="text-center"
                    @filtered="onFiltered"
                >
                    <!-- id -->
                    <template v-slot:cell(id)="row">
                        <div class="d-flex justify-content-center">
                            {{row.item.id}}
                        </div>
                    </template>
                    <!-- order -->
                    <template v-slot:cell(order)="row">
                        <div class="d-flex justify-content-center">
                            {{row.item.order}}
                        </div>
                    </template>
                    <!-- active -->
                    <template v-slot:cell(active)="row">
                        <div class="d-flex justify-content-around">
                            <b-icon-sun
                                :variant="row.item.active ? 'success' : 'danger'"
                                scale="1.2"
                            ></b-icon-sun>
                        </div>
                    </template>
                    <!-- actions -->
                    <template v-slot:cell(action)="row">
                        <div class="d-flex justify-content-around">
                            <!--                            &lt;!&ndash; detail show &ndash;&gt;
                                                        <b-icon-caret-down-square
                                                            v-if="!row.detailsShowing"
                                                            v-b-tooltip.hover
                                                            :title="$t('form.detail_show')"
                                                            scale="1.2"
                                                            style="cursor: pointer; margin-right: 3px;"
                                                            variant="secondary"
                                                            @click="row.toggleDetails"
                                                        ></b-icon-caret-down-square>
                                                        &lt;!&ndash; detail hide &ndash;&gt;
                                                        <b-icon-caret-up-square-fill
                                                            v-if="row.detailsShowing"
                                                            v-b-tooltip.hover
                                                            :title="$t('form.detail_hide')"
                                                            scale="1.2"
                                                            style="cursor: pointer; margin-right: 3px;"
                                                            variant="secondary"
                                                            @click="row.toggleDetails"
                                                        ></b-icon-caret-up-square-fill>-->
                            <!-- edit -->
                            <b-icon-file-text
                                v-if="!row.item.system"
                                v-b-tooltip.hover
                                :title="$t('form.edit')"
                                scale="1.2"
                                style="cursor: pointer; margin-right: 3px;"
                                variant="secondary"
                                @click="recordEdit(row.item)"
                            ></b-icon-file-text>
                            <!-- delete -->
                            <b-icon-trash
                                v-if="!row.item.system"
                                v-b-tooltip.hover
                                :title="$t('form.delete')"
                                scale="1.2"
                                style="cursor: pointer;"
                                variant="danger"
                                @click="recordDelete(row.item)"
                            ></b-icon-trash>
                        </div>
                    </template>
                    <!-- row detail -->
                    <template v-slot:row-details="row">
                        <show-admin-organisation
                            :content="tableRowDetail(row.item.id)"
                            :data="data.data"
                        ></show-admin-organisation>
                    </template>
                </b-table>
                <!-- pagination -->
                <b-pagination
                    v-model="tableToolbar.options.pagination.currentPage"
                    :per-page="tableToolbar.options.pagination.perPage"
                    :total-rows="this.tableToolbar.options.filterCount"
                    aria-controls="main-table"
                    limit="20"
                    size="sm"
                ></b-pagination>
            </b-container>
        </b-overlay>
        <!-- modalFormXxx -->
        <ModalFormOrganisation
            :form="form"
            :locale-key="localeKey"
            :modal-bus.sync="modalBus"
            :uri="uri"
            @refresh="modalEventRefresh"
        ></ModalFormOrganisation>
    </div>
</template>

<script>
import Vue from "vue";
import TableToolbar from "@/components/general/elements/tableAccessories/TableToolbar";
import ModalFormOrganisation from "@/components/admin/organisation/ModalFormOrganisation";

export default {
    name: "Organisations",
    components: {ModalFormOrganisation, TableToolbar},
    props: {},
    data() {
        return {
            overlay: {
                visible: false,
                opacity: 0.7,
            },
            localeKey: 'admin.organisation.main',
            uri: {
                main: `api/v1/admin/organisations`,
                uri1: `api/v1/admin/organisation`,
            },
            table: {
                items: [],
                fields: [],
                columns: [
                    // <-- organisation -->
                    {
                        key: 'id',
                        label: this.$t('form.id'),
                        sortable: true,
                        show: true,
                    },
                    {
                        key: 'name',
                        label: this.$t('organisation.name'),
                        sortable: true,
                        alwaysShow: true,
                    },
                    {
                        key: 'org_type',
                        label: this.$t('organisation.type'),
                        sortable: true,
                        show: false,
                    },
                    {
                        key: 'taxpayer_type',
                        label: this.$tc('register.taxpayer_type', 1),
                        sortable: true,
                        show: false,
                    },
                    {
                        key: 'taxpayer',
                        label: this.$tc('finance.taxpayer', 0),
                        sortable: true,
                        show: false,
                        formatter: value => {
                            switch (value) {
                                case true:
                                    return this.$t('form.yes');
                                case false:
                                    return this.$t('form.no');
                                default:
                                    return '?';
                            }
                        }
                    },
                    {
                        key: 'tax_number',
                        label: this.$t('organisation.tax_number'),
                        sortable: true,
                        show: true,
                    },
                    {
                        key: 'phone',
                        label: this.$t('organisation.phone'),
                        sortable: true,
                        show: true,
                    },
                    {
                        key: 'email',
                        label: this.$t('organisation.email'),
                        sortable: true,
                        show: true,
                    },
                    {
                        key: 'internet_contact',
                        label: this.$t('organisation.internet_contact'),
                        sortable: true,
                        show: false,
                    },

                    {
                        key: 'region',
                        label: this.$t('address.region'),
                        sortable: true,
                        show: false,
                    },
                    {
                        key: 'state',
                        label: this.$t('address.state'),
                        sortable: true,
                        show: false,
                    },

                    {
                        key: 'bank',
                        label: this.$t('organisation.bank_name'),
                        sortable: true,
                        show: false,
                    },
                    {
                        key: 'bank_account',
                        label: this.$t('organisation.bank_account'),
                        sortable: true,
                        show: false,
                    },

                    {
                        key: 'partnership',
                        label: this.$t('organisation.partnership'),
                        sortable: true,
                        show: false,
                    },
                    {
                        key: 'liaison',
                        label: this.$t('organisation.liaison'),
                        sortable: true,
                        show: false,
                    },
                    // <-- user -->
                    {
                        key: 'user',
                        label: this.$tc('admin.user.main', 0),
                        sortable: true,
                        show: false,
                    },
                    /*                    {
                                            key: 'user_id',
                                            label: '**User_id', // this.$t('organisation.user_id'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'username',
                                            label: this.$t('user.username'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'user_name',
                                            label: this.$t('user.name'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'user_surname',
                                            label: this.$t('user.surname'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'user_email',
                                            label: this.$t('user.email'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'user_phone',
                                            label: this.$t('user.phone'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'user_email',
                                            label: this.$t('user.email'),
                                            sortable: true,
                                            show: false,
                                        },
                                        {
                                            key: 'user_internet_contact',
                                            label: this.$t('user.internet_contact'),
                                            sortable: true,
                                            show: false,
                                        },*/
                    // <--  -->
                    {
                        key: 'order',
                        label: this.$t('form.order'),
                        sortable: true,
                        show: false,
                    },
                    {
                        key: 'active',
                        label: this.$t('form.active'),
                        sortable: true,
                        show: false,
                    },
                ],
                sortBy: 'id',
                sortDesc: false,
            },
            tableToolbar: {
                options: {
                    filterCount: 0,
                    rowsCount: 0,
                    pagination: {
                        perPage: 10,
                        currentPage: 1,
                    },
                },
                response: {}
            },
            form: {},
            // <-- set -->
            data: [],
            modalBus: new Vue(),
        }
    },
    mounted() {
        this.baseSelect();
    },
    methods: {
        showOverlay(show) {
            this.overlay.visible = show;
        },
        // <--  -->
        getUser(userIn) {
            let user = null;
            // <-- name, surname -->
            if (userIn.personal_data[0] !== undefined && userIn.personal_data[0].name !== undefined) {
                let nameObject = userIn.personal_data[0].name;
                if (nameObject.name !== null && nameObject.name !== undefined && nameObject.name.length > 0) {
                    user = nameObject.name;
                }
                if (nameObject.surname !== null && nameObject.surname !== undefined && nameObject.surname.length > 0) {
                    user += user != null ? ' ' : '';
                    user += nameObject.surname;
                }
            }
            // <--  -->
            return user === null ? userIn.email : user;
        },
        getOrgType(type) {
            if (type === null) {
                return null;
            }
            // <--  -->
            let string = type.meta.name === null || type.meta.name.length === 0 ? null : type.meta.name;
            if (string === null && type.meta.full_name !== null && type.meta.full_name.length < 0) {
                string = type.meta.full_name;
            }
            // <--  -->
            return string;
        },
        getTaxpayerType(type) {
            if (type === null) {
                return null;
            }
            // <--  -->
            let string = type.meta.name === null || type.meta.name.length === 0 ? null : type.meta.name;
            if (string === null && type.meta.full_name !== null && type.meta.full_name.length < 0) {
                string = type.meta.full_name;
            }
            // <-- locale -->
            if (type.locale[this.$i18n.locale] !== undefined && type.locale[this.$i18n.locale].name !== undefined) {
                if (type.locale[this.$i18n.locale].name !== null && type.locale[this.$i18n.locale].name.length > 0) {
                    string = type.locale[this.$i18n.locale].name;
                }
            }
            // <--  -->
            return string;
        },
        getRegion(regionIn) {
            if (regionIn === null) {
                return {
                    name: null,
                    state_name: null
                }
            }
            // <--  -->
            return {
                name: regionIn.meta.name,
                state_name: this.__getStateName(this.data.data.states, regionIn.state_id)
            };
        },
        getBank(bank_id, bank_account, bank) {
            // <-- bank -->
            if (bank_id > 0) {
                return {
                    account: bank_account.account,
                    bank_name: bank.meta.name
                }
            }
            // <--  -->
            return {
                account: bank_account.account,
                bank_name: bank_account.bank_custom
            }
        },
        getPartnership(partnership) {
            let string = null;
            // <-- check -->
            if (this.__isNull(partnership)) {
                return null;
            }
            // <--  -->
            let keys = Object.keys(partnership);
            let name;
            keys.find((key) => {
                if (partnership[key]) {
                    this.data.data.partnership_types.find((ps) => {
                        if (this.__createJsonKey(ps.meta.name) === this.__createJsonKey(key)) {
                            name = ps.meta.name;
                            // <-- locale -->
                            if (ps.locale[this.$i18n.locale] !== undefined) {
                                if (!this.__isNull(ps.locale[this.$i18n.locale].name)) {
                                    name = ps.locale[this.$i18n.locale].name;
                                }
                            }
                            string = string === null ? '' : string + ', ';
                            string += name;
                        }
                    });
                }
            });
            // <--  -->
            return string;
        },
        // <-- toolbarTable -->
        toolbarTableEventRefresh() {
            this.baseSelect();
        },
        toolbarTableEventNew() {
            this.recordNew();
        },
        // <-- modalForm -->
        modalEventRefresh(data) {
            this.$set(this, 'data', data);
        },
        // <-- table -->
        onFiltered(filteredItems) {
            this.tableToolbar.options.filterCount = filteredItems.length;
            this.tableToolbar.options.pagination.currentPage = 1;
        },
        tableRowDetail(id) {
            return this.data.records.find((n) => {
                if (n.id === id) {
                    if (n.post_office !== null && n.post_office[0] !== undefined && n.id === id) {
                        n.state = this.__getStateObject(this.data.data.states, n.post_office[0].state_id);
                    }
                    return n;
                }
            });
        },
        // <-- record -->
        recordNew() {
            // this.$set(this.form, 'id', 0);
            // this.$bvModal.show('ModalFormOrganisation');
            this.modalBus.$emit('modalOpen', 0);
        },
        recordEdit(row) {
            // this.$set(this.form, 'id', row.id);
            // this.$bvModal.show('ModalFormOrganisation');
            this.modalBus.$emit('modalOpen', row.id);
        },
        recordDelete(row) {
            const h = this.$createElement;
            const messageHTML = h('div', [
                h('span', [
                    `${this.$t('form.delete_message.pre')} ${this.$tc(this.localeKey, 2)} `,
                    h('strong', row.name), this.$t('form.delete_message.post'),
                ])
            ]);
            // <-- message box -->
            this.$bvModal.msgBoxConfirm([messageHTML], {
                title: this.$t('form.please_confirm'),
                // size: 'sm',
                // buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.$t('form.delete'),
                cancelTitle: this.$t('form.cancel'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.baseDelete(row.id);
                    }
                })
                .catch(err => {
                    // on error executed
                })
        },
        // <-- api calls -->
        baseSelect: function () {
            this.showOverlay(true);
            // <-- api -->
            const config = {
                headers: this.__getHeaders()
            };
            // <-- axios -->
            this.axios.get(this.uri.main, config)
                .then((response) => {
                    this.$set(this, 'data', response.data);
                    this.showOverlay(false);
                })
                .catch((error) => {
                    // console.log("ERROR:", error.response.data);
                    this.showOverlay(false);
                });
        },
        baseDelete(record_id) {
            this.showOverlay(true);
            // <-- api -->
            const config = {
                headers: this.__getHeaders()
            };
            // <-- axios -->
            this.axios.delete(this.uri.main + `/${record_id}`, config)
                .then((response) => {
                    this.data = response.data;
                    this.showOverlay(false);
                })
                .catch((error) => {
                    // console.log("error:", error);
                })
                .finally(function () {
                    // always executed
                });
        },
    },
    computed: {
        // <-- tableToolbar -->
        tableToolbarColumns() {
            return this.__getTableToolbarColumns(this.table.columns);
        },
        // <-- table -->
        tableColumns() {
            let columns = this.table.columns;
            let columnsShow = this.tableToolbar.response.columnsShow;
            // <-- check if exists -->
            if (columns === undefined) {
                return [];
            }
            // <--  -->
            let values = [];
            columns.forEach(column => {
                if (column.alwaysShow || (columnsShow != null && columnsShow.indexOf(column.key) >= 0)) {
                    values.push({
                        key: column.key,
                        label: column.label,
                        formatter: column.formatter,
                        sortable: column.sortable,
                        show: column.show,
                    });
                }
            });
            // <-- add column actions -->
            values.push({
                key: 'action',
                label: '',
                id: 0,
                sortable: false,
                thStyle: {width: '60px'}    //85px for 3 icons
                // variant: 'danger',
            });
            // <--  -->
            return values;
        },
        tableItems() {
            if (this.data.records === undefined) {
                return [];
            }
            // <--  -->
            let records = this.data.records;
            // <-- check if exists -->
            if (records.length === 0) {
                return [];
            }
            // <--  -->
            let items = [];
            let item = {};
            let name, contact, region, bank, extended;
            records.forEach(record => {
                name = this.__isNull(record.name.name) ? record.name.full_name : record.name.name;
                contact = this.__getTableValuesObjectDefault(record.contact);
                region = this.getRegion(record.region_id > 0 ? record.region : null);
                bank = this.getBank(record.bank_id, record.bank_account, record.bank)
                extended = record.extended === undefined ? null : record.extended;
                // <-- set item -->
                item = {
                    id: record.id,
                    name: name,
                    org_type: this.getOrgType(record.org_type),
                    taxpayer_type: this.getTaxpayerType(record.taxpayer_type),
                    taxpayer: record.taxpayer,
                    tax_number: record.tax_number,

                    liaison: extended === null ? null : extended.liaison,

                    phone: contact.phone === undefined ? null : contact.phone.value_c,
                    email: contact.email === undefined ? null : contact.email.value_c,
                    internet_contact: contact.internet_contact === undefined ? null : contact.internet_contact.value_c,

                    region: region.name,
                    state: region.state_name,

                    bank: bank.bank_name,
                    bank_account: bank.account,

                    partnership: this.getPartnership(record.partnership),

                    user: this.getUser(record.user),

                    order: record.order,
                    active: record.active,
                }
                items.push(item);
            });
            // <--  -->
            this.tableToolbar.options.filterCount = items.length;
            this.tableToolbar.options.rowsCount = items.length;
            return items;
        },
    },
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
